function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49 22.334h222c7.548 0 13.666 6.119 13.666 13.666v290c0 7.547-6.118 13.666-13.666 13.666H49c-7.547 0-13.666-6.118-13.666-13.666V36c0-7.547 6.118-13.666 13.666-13.666z",
  fill: "var(--modal_card_background)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.333 41.708h149.334a5.005 5.005 0 014.999 5.01v18.038a5.005 5.005 0 01-4.999 5.01H50.333a5.004 5.004 0 01-4.999-5.01V46.718a5.005 5.005 0 015-5.01zm-2 31.399h74c1.656 0 3 1.345 3 3.006v4.009a3.003 3.003 0 01-3 3.006h-74a3.003 3.003 0 01-2.999-3.006v-4.009a3.003 3.003 0 013-3.006zm1.334 24.719h102c3.496 0 6.332 2.84 6.332 6.346v10.689c0 3.506-2.836 6.347-6.332 6.347h-102c-3.497 0-6.333-2.841-6.333-6.347v-10.689c0-3.506 2.836-6.346 6.333-6.346z",
  fill: "var(--control_background)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.667 108.181c0-3.742 0-5.613.726-7.042a6.676 6.676 0 012.914-2.92c1.426-.727 3.292-.727 7.026-.727h92c3.734 0 5.601 0 7.027.728a6.668 6.668 0 012.913 2.919c.727 1.429.727 3.3.727 7.042v2.672c0 3.742 0 5.612-.727 7.041a6.668 6.668 0 01-2.913 2.92c-1.426.728-3.293.728-7.027.728h-92c-3.734 0-5.6 0-7.026-.728a6.675 6.675 0 01-2.914-2.92c-.726-1.429-.726-3.299-.726-7.041v-2.672z",
  fill: "var(--button_primary_background)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.016 109.721h.971c.987 0 1.553.445 1.553 1.159v.01c0 .705-.605 1.174-1.518 1.174-.894 0-1.504-.401-1.577-1.071l-.005-.034h-1.065v.048c.083 1.219 1.133 2.021 2.647 2.021 1.484 0 2.631-.89 2.631-2.084v-.01c0-.988-.654-1.62-1.567-1.712v-.083c.781-.181 1.323-.833 1.323-1.606v-.009c0-1.116-.976-1.899-2.363-1.899-1.435 0-2.383.754-2.48 1.967l-.01.078h1.05l.005-.034c.068-.66.595-1.047 1.401-1.047.825 0 1.313.407 1.313 1.047v.01c0 .68-.532 1.15-1.367 1.15h-.942v.925zm6.28 3.224c.703 0 1.26-.303 1.573-.841h.082v.753h1.05v-3.635c0-1.116-.752-1.781-2.084-1.781-1.206 0-2.042.582-2.168 1.453l-.006.034h1.021l.005-.02c.127-.377.513-.592 1.098-.592.718 0 1.084.324 1.084.906v.469l-1.435.084c-1.265.078-1.977.631-1.977 1.58v.01c0 .964.746 1.58 1.757 1.58zm-.703-1.624v-.01c0-.479.332-.744 1.064-.788l1.294-.083v.455c0 .685-.58 1.204-1.372 1.204-.571 0-.986-.289-.986-.778zm4.835 1.536h1.06v-4.477h2.358v4.477h1.055v-5.314h-4.473v5.314zm5.924 0h1.05l2.397-3.743h.094v3.743h1.049v-5.314h-1.049l-2.398 3.729h-.093v-3.729h-1.05v5.314zm8.288.103c1.314 0 2.07-.709 2.26-1.742l.01-.044h-1.015l-.01.024c-.171.573-.581.876-1.245.876-.874 0-1.417-.714-1.417-1.888v-.01c0-1.146.533-1.85 1.417-1.85.703 0 1.133.392 1.25.915l.005.015 1.015-.005v-.025c-.147-1.032-.942-1.785-2.275-1.785-1.548 0-2.49 1.052-2.49 2.735v.01c0 1.717.947 2.774 2.495 2.774zm4.864-.015c.704 0 1.26-.303 1.572-.841h.084v.753h1.049v-3.635c0-1.116-.752-1.781-2.085-1.781-1.206 0-2.041.582-2.168 1.453l-.005.034h1.021l.005-.02c.126-.377.512-.592 1.098-.592.718 0 1.085.324 1.085.906v.469l-1.436.084c-1.265.078-1.978.631-1.978 1.58v.01c0 .964.748 1.58 1.758 1.58zm-.703-1.624v-.01c0-.479.332-.744 1.064-.788l1.295-.083v.455c0 .685-.582 1.204-1.373 1.204-.571 0-.986-.289-.986-.778zm8.8-3.778h-4.4v.837h1.67v4.477h1.06v-4.477h1.67v-.837zm1.022 5.314h2.099c1.231 0 2.017-.709 2.017-1.83v-.01c0-1.115-.786-1.825-2.017-1.825h-1.04v-1.649h-1.059v5.314zm2.011-2.828c.635 0 1.04.392 1.04.988v.01c0 .592-.4.994-1.04.994h-.952v-1.992h.952zm5.455 2.931c1.314 0 2.071-.709 2.261-1.742l.01-.044h-1.016l-.009.024c-.171.573-.582.876-1.246.876-.874 0-1.415-.714-1.415-1.888v-.01c0-1.146.531-1.85 1.415-1.85.704 0 1.133.392 1.25.915l.005.015 1.016-.005v-.025c-.146-1.032-.942-1.785-2.275-1.785-1.548 0-2.491 1.052-2.491 2.735v.01c0 1.717.947 2.774 2.495 2.774zm6.183-.103h1.046v-5.314h-2.042c-1.225 0-2.026.68-2.026 1.781v.01c0 .725.449 1.292 1.181 1.502l-1.45 2.021h1.221l1.289-1.84h.781v1.84zm-.942-2.652c-.63 0-1.016-.371-1.016-.881v-.01c0-.581.381-.939 1.016-.939h.942v1.83h-.942z",
  fill: "var(--button_primary_foreground)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77 133.901h8a3.67 3.67 0 013.666 3.675v8.016A3.67 3.67 0 0185 149.267h-8a3.67 3.67 0 01-3.666-3.675v-8.016A3.67 3.67 0 0177 133.901zm-31.333 49.437h8a3.67 3.67 0 013.666 3.675v8.016a3.67 3.67 0 01-3.666 3.675h-8A3.67 3.67 0 0142 195.029v-8.016a3.67 3.67 0 013.666-3.675zm0 22.715h8a3.67 3.67 0 013.666 3.674v8.017a3.67 3.67 0 01-3.666 3.674h-8A3.67 3.67 0 0142 217.744v-8.017a3.67 3.67 0 013.666-3.674zm0 45.428h8a3.67 3.67 0 013.666 3.674v8.017a3.67 3.67 0 01-3.666 3.675h-8A3.67 3.67 0 0142 263.172v-8.017a3.67 3.67 0 013.666-3.674zm0 21.378h8a3.67 3.67 0 013.666 3.675v8.016a3.67 3.67 0 01-3.666 3.675h-8A3.67 3.67 0 0142 284.55v-8.016a3.67 3.67 0 013.666-3.675zm0 21.378h8a3.67 3.67 0 013.666 3.675v8.017a3.67 3.67 0 01-3.666 3.674h-8A3.67 3.67 0 0142 305.929v-8.017a3.67 3.67 0 013.666-3.675zM245 183.338c4.233 0 7.666 3.439 7.666 7.683s-3.433 7.683-7.666 7.683c-4.233 0-7.666-3.439-7.666-7.683s3.433-7.683 7.666-7.683zM277.667 191.021c0-4.796-3.88-8.685-8.667-8.685-4.786 0-8.667 3.889-8.667 8.685 0 4.797 3.881 8.685 8.667 8.685 4.787 0 8.667-3.888 8.667-8.685zm-121.334-57.12h8.001a3.67 3.67 0 013.665 3.675v8.016a3.67 3.67 0 01-3.665 3.675h-8.001a3.67 3.67 0 01-3.665-3.675v-8.016a3.67 3.67 0 013.665-3.675zm80 0h8a3.67 3.67 0 013.666 3.675v8.016a3.67 3.67 0 01-3.666 3.675h-8a3.67 3.67 0 01-3.665-3.675v-8.016a3.67 3.67 0 013.665-3.675zm-180 20.042H105a2.336 2.336 0 012.333 2.339v4.008a2.335 2.335 0 01-2.333 2.338H56.333a2.335 2.335 0 01-2.332-2.338v-4.008a2.335 2.335 0 012.332-2.339zM67 185.342h130.667a2.336 2.336 0 012.332 2.339v6.68a2.336 2.336 0 01-2.332 2.339H67a2.336 2.336 0 01-2.332-2.339v-6.68A2.336 2.336 0 0167 185.342zm0 22.715h205.333a2.335 2.335 0 012.333 2.338v32.735a2.335 2.335 0 01-2.333 2.338H67a2.335 2.335 0 01-2.332-2.338v-32.735A2.335 2.335 0 0167 208.057zm0 44.76h63.333a2.335 2.335 0 012.333 2.338v7.349a2.335 2.335 0 01-2.333 2.338H67a2.335 2.335 0 01-2.332-2.338v-7.349A2.335 2.335 0 0167 252.817zm0 21.378h90.667a2.336 2.336 0 012.332 2.339v7.348a2.336 2.336 0 01-2.332 2.339H67a2.336 2.336 0 01-2.332-2.339v-7.348A2.336 2.336 0 0167 274.195zm0 21.379h151.333a2.335 2.335 0 012.333 2.338v7.349a2.335 2.335 0 01-2.333 2.338H67a2.335 2.335 0 01-2.332-2.338v-7.349A2.335 2.335 0 0167 295.574zm68.667-141.631h48.666a2.336 2.336 0 012.333 2.339v4.008a2.335 2.335 0 01-2.333 2.338h-48.666a2.335 2.335 0 01-2.333-2.338v-4.008a2.336 2.336 0 012.333-2.339zm77.333 0h54.667a2.335 2.335 0 012.332 2.339v4.008a2.335 2.335 0 01-2.332 2.338H213a2.335 2.335 0 01-2.332-2.338v-4.008a2.335 2.335 0 012.332-2.339z",
  fill: "var(--control_background)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.667 191.021c0-4.796-3.88-8.685-8.667-8.685-4.786 0-8.667 3.889-8.667 8.685 0 4.797 3.881 8.685 8.667 8.685 4.787 0 8.667-3.888 8.667-8.685z",
  fill: "var(--control_background)",
  stroke: "var(--modal_card_background)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.667 191.021c0-4.796-3.88-8.685-8.667-8.685-4.786 0-8.667 3.889-8.667 8.685 0 4.797 3.881 8.685 8.667 8.685 4.787 0 8.667-3.888 8.667-8.685z",
  fill: "var(--control_background)",
  stroke: "var(--modal_card_background)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.667 191.021c0-4.796-3.88-8.685-8.667-8.685-4.786 0-8.667 3.889-8.667 8.685 0 4.797 3.881 8.685 8.667 8.685 4.787 0 8.667-3.888 8.667-8.685z",
  fill: "var(--control_background)",
  stroke: "var(--modal_card_background)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 -1 0 304)",
  fill: "url(#paint0_linear)",
  d: "M0 0h320v112H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 320,
  y1: 112,
  x2: 320,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "var(--background_content)",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "var(--background_content)",
  stopOpacity: 0.016
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188,
  stopColor: "var(--background_content)",
  stopOpacity: 0.055
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "var(--background_content)",
  stopOpacity: 0.118
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.382,
  stopColor: "var(--background_content)",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "var(--background_content)",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "var(--background_content)",
  stopOpacity: 0.392
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.657,
  stopColor: "var(--background_content)",
  stopOpacity: 0.502
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.739,
  stopColor: "var(--background_content)",
  stopOpacity: 0.608
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.812,
  stopColor: "var(--background_content)",
  stopOpacity: 0.71
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "var(--background_content)",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  stopColor: "var(--background_content)",
  stopOpacity: 0.882
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.967,
  stopColor: "var(--background_content)",
  stopOpacity: 0.945
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.991,
  stopColor: "var(--background_content)",
  stopOpacity: 0.984
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--background_content)"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: 11,
  y: 0,
  width: 298,
  height: 366,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

var SvgActionButtonPreviewMobile = function SvgActionButtonPreviewMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 320 300",
    preserveAspectRatio: "xMidYMax meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionButtonPreviewMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action-button-preview-mobile.dbc54d88.svg";
export { ForwardRef as ReactComponent };